(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bep-reviews-signature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bep-review-carousel')) {
    customElements.define('bep-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        this.progress = this.querySelector('[data-review-progress]');
        this.items = [...this.querySelectorAll('.bep-review-signature__item')];
        if (!this.track || this.items.length < 2) return;
        this.style.setProperty('--bep-review-count', this.items.length);
        this.previous?.addEventListener('click', () => this.move(-1));
        this.next?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.update();
      }

      move(direction) {
        const distance = this.items[0].getBoundingClientRect().width + 14;
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      update() {
        if (!this.progress) return;
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const ratio = maximum > 0 ? this.track.scrollLeft / maximum : 0;
        const travel = (this.items.length - 1) * 100;
        this.style.setProperty('--bep-review-progress', `${ratio * travel}%`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bep-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-bep-video-hero]';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialize = (hero) => {
      if (hero.dataset.videoHeroReady === 'true') return;
      hero.dataset.videoHeroReady = 'true';

      const control = hero.querySelector('[data-bep-video-control]');
      const videos = [...hero.querySelectorAll('video')];
      if (!control || videos.length === 0) return;

      let manuallyPaused = reducedMotion.matches;
      let playbackReady = false;

      const activeVideo = () => {
        const mobileVideo = hero.querySelector('.bep-video-hero__video--mobile');
        const desktopVideo = hero.querySelector('.bep-video-hero__video--desktop');
        return mobileQuery.matches && mobileVideo ? mobileVideo : desktopVideo || mobileVideo;
      };

      const sync = () => {
        const selectedVideo = activeVideo();
        videos.forEach((video) => {
          if (video !== selectedVideo || manuallyPaused || reducedMotion.matches || hero.dataset.autoplay !== 'true' || !playbackReady) {
            video.pause();
          } else {
            video.play().catch(() => {
              manuallyPaused = true;
            });
          }
        });
        const paused = manuallyPaused || reducedMotion.matches || selectedVideo?.paused;
        control.classList.toggle('is-paused', Boolean(paused));
        control.setAttribute('aria-label', paused ? hero.dataset.playLabel : hero.dataset.pauseLabel);
      };

      control.addEventListener('click', () => {
        playbackReady = true;
        manuallyPaused = !manuallyPaused;
        sync();
      });
      mobileQuery.addEventListener('change', sync);
      reducedMotion.addEventListener('change', sync);
      sync();

      const beginPlayback = () => {
        if (reducedMotion.matches || hero.dataset.autoplay !== 'true') return;
        playbackReady = true;
        sync();
      };

      const schedulePlayback = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(beginPlayback, { timeout: 1800 });
        } else {
          window.setTimeout(beginPlayback, 900);
        }
      };

      if (document.readyState === 'complete') {
        schedulePlayback();
      } else {
        window.addEventListener('load', schedulePlayback, { once: true });
      }
    };

    document.querySelectorAll(selector).forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(selector).forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
